import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link, useHistory } from "react-router-dom";
import useSaleFactorStore from "../../../store/out-warehouse/useSaleFactorStore";

const useStyles = makeStyles((theme) => ({
  buyFactorListItem: {
    padding: "10px 16px",
    backgroundColor: "#fff",
    marginBottom: "1rem",
    borderRadius: "11px",
    display: "flex",
    justifyContent: "space-between",
    "& span": {
      color: "#ABACBE",
    },
  },
  more: {
    minWidth: "70px",
    textAlign: "left",
    lineHeight: "76px",
    borderRight: "1px dashed #B9BACC",
    fontSize: "0.875rem",
    position: "relative",
    paddingLeft: "12px",
    [theme.breakpoints.down("360")]: {
      paddingLeft: "7px",
      minWidth: "60px",
    },
    "&:before": {
      position: "absolute",
      content: '""',
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      backgroundColor: "#F4F4F8",
      top: "-16px",
      right: "-7px",
    },
    "&:after": {
      position: "absolute",
      content: '""',
      width: "14px",
      height: "14px",
      borderRadius: "50%",
      backgroundColor: "#F4F4F8",
      bottom: "-16px",
      right: "-7px",
    },
  },
}));

const SaleFactorsNested = ({ id, user_name, date }) => {
  const classes = useStyles();
  const history = useHistory();
  const setFactorID = useSaleFactorStore((store) => store.setFactorID);

  const navigate = (id) => {
    setFactorID(id);
    history.push(`out-with-factor-detail/${id}`);
  };

  return (
    <Box className={classes.buyFactorListItem}>
      <Box>
        <Typography variant="h3" mb={0.75}>
          <span>نام تحویل گیرنده:</span>
          <Box display="inline-block" mr={0.75} fontWeight="700">
            {user_name}
          </Box>
        </Typography>
        <Typography variant="h3" mb={0.75}>
          <span>شماره فاکتور:</span>
          <Box display="inline-block" mr={0.75} fontWeight="700">
            {id}
          </Box>
        </Typography>
        <Typography variant="h3">
          <span>تاریخ ثبت:</span>
          <Box display="inline-block" mr={0.75} fontWeight="700">
            {date}
          </Box>
        </Typography>
      </Box>
      <Box className={classes.more} onClick={() => navigate(id)}>
        نمایش
      </Box>
    </Box>
  );
};
export default SaleFactorsNested;
